module.exports = __webpack_public_path__ + "static/media/man.e09cda57.png";